'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearIndustries = exports.fetchIndustries = exports.clearOccupations = exports.fetchOccupations = undefined;
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
var _constants = require('../constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

// This feels a bit wet - I pasted instructor actions from introducer-select.js,
// then pasted again. When things ease up, if you stumble accross this look into finding a better way.
// Ben M

var fetchOccupations = exports.fetchOccupations = function fetchOccupations(formId, product, query) {
  return {
    type: _constants.actionTypes.FETCH_OCCUPATIONS,
    payload: _axios2.default.get(_constants.employmentUrls.occupations, {
      params: {
        product: product,
        query: query
      }
    }).then(function (response) {
      window.dataLayer.push({
        event: 'aa_lookup',
        aa: {
          lookup_name: 'employment occupation',
          lookup_result: 'success',
          error_message: ''
        }
      });
      return response.data.data;
    }, function (error) {
      window.dataLayer.push({
        event: 'aa_lookup',
        aa: {
          lookup_name: 'employment occupation',
          lookup_result: 'failure',
          error_message: error.message
        }
      });
      throw error;
    }),
    meta: {
      formId: formId
    }
  };
};
var clearOccupations = exports.clearOccupations = function clearOccupations(formId) {
  return {
    type: _constants.actionTypes.CLEAR_OCCUPATIONS,
    formId: formId
  };
};
var fetchIndustries = exports.fetchIndustries = function fetchIndustries(formId, product, query) {
  return {
    type: _constants.actionTypes.FETCH_INDUSTRIES,
    payload: _axios2.default.get(_constants.employmentUrls.industries, {
      params: {
        product: product,
        query: query
      }
    }).then(function (response) {
      window.dataLayer.push({
        event: 'aa_lookup',
        aa: {
          lookup_name: 'employment industry',
          lookup_result: 'success',
          error_message: ''
        }
      });
      return response.data.data;
    }, function (error) {
      window.dataLayer.push({
        event: 'aa_lookup',
        aa: {
          lookup_name: 'employment industry',
          lookup_result: 'failure',
          error_message: error.message
        }
      });
      throw error;
    }),
    meta: {
      formId: formId
    }
  };
};
var clearIndustries = exports.clearIndustries = function clearIndustries(formId) {
  return {
    type: _constants.actionTypes.CLEAR_INDUSTRIES,
    formId: formId
  };
};